import { render, staticRenderFns } from "./tenderEdit.vue?vue&type=template&id=9210ce34&scoped=true"
import script from "./tenderEdit.vue?vue&type=script&lang=js"
export * from "./tenderEdit.vue?vue&type=script&lang=js"
import style0 from "./tenderEdit.vue?vue&type=style&index=0&id=9210ce34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9210ce34",
  null
  
)

export default component.exports